import { useEffect, useMemo, useState } from "react";
export default function useIntersection(ref) {
    var _a = useState(), isIntersecting = _a[0], setIntersecting = _a[1];
    var observer = useMemo(function () { return new IntersectionObserver(function (_a) {
        var entry = _a[0];
        return setIntersecting(entry);
    }); }, [ref]);
    useEffect(function () {
        if (ref.current) {
            observer.observe(ref.current);
        }
        return function () { return observer.disconnect(); };
    }, [observer]);
    if (!isIntersecting)
        return;
    return isIntersecting;
}
